import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { authenticationService } from '../../services/authenticationService.js';
import Loader from '../../components/loader/loader.jsx';
import LanguageMenu from '../../components/languageSelector/languageSelector.jsx';
import * as styles from "./login.module.scss"

class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        if (authenticationService.currentUserValue) {
            this.props.history.push('/');
        }

        this.state = {
            userData: { userName: '', password: '' },
            loginError: '',
            isSubmitting: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.userNameChanged = this.userNameChanged.bind(this);
        this.userPasswordChanged = this.userPasswordChanged.bind(this);
        this.setError = this.setError.bind(this);
    }

    setSubmitting(value) {
        let data = Object.assign({}, this.state);
        data.isSubmitting = value;
        this.setState(data);
    }

    userNameChanged(e) {
        let data = Object.assign({}, this.state);
        data.userData.userName = e.target.value;
        this.setState(data);
    }

    userPasswordChanged(e) {
        let data = Object.assign({}, this.state);
        data.userData.password = e.target.value;
        this.setState(data);
    }

    setError(error) {
        let data = Object.assign({}, this.state);
        if (error) {
            if (error.message && (error.message === "UserNotFound" || error.message === "PasswordError")) {
                data.loginError = "LoginPage.UserPasswordError";
            } else {
                data.loginError = "LoginPage.UnknownServerError";
            }
        } else {
            return;
        }
        
        this.setState(data);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setSubmitting(true);
        authenticationService.login(this.state.userData.userName, this.state.userData.password).then(
            user => {
                const { from } = this.props.location.state || { from: { pathname: "/" } };
                this.setError(null);
                // this.setSubmitting(false);
                this.props.history.push(from);
            },
            error => {
                this.setError(error);
                this.setSubmitting(false);
            }
        );
    }

    render() {
        return (
            <div id="loginPage">
                <div className={styles.login_form_container}>
                    <form onSubmit={this.handleSubmit}>
                        <p>
                            <label><Trans>LoginPage.UserNameText</Trans></label><br/>
                            <input type="text" onChange={this.userNameChanged}/>
                        </p>
                        <p>
                            <label><Trans>LoginPage.PasswordText</Trans></label><br/>
                            <input type="password" onChange={this.userPasswordChanged}/>
                        </p>
                        <p>
                            <label style={{
                                display: this.state.loginError ? "block" : "none",
                                color: "#e62d20",
                                margin: 'auto',
                                width: 'fit-content'
                            }}><Trans>{
                                this.state.loginError}</Trans></label>
                        </p>

                        <button type="submit"><Trans>LoginPage.LoginButtonText</Trans></button>
                        {this.state.isSubmitting && <Loader className="loginLoader"/>}

                    </form>
                </div>
                <LanguageMenu />
            </div>
        );
    }
}

export default withTranslation('translantions')(LoginPage);
